/*
 * @Author: Liux
 * @Date: 2019-12-27 07:58:07
 * @LastEditor: Liux
 * @LastEditTime: 2020-09-16 09:47:04
 */
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdCheckBoxComponent } from './ad-check-box.component';

@NgModule({
  declarations: [AdCheckBoxComponent],
  imports: [CommonModule, FormsModule],
  exports: [AdCheckBoxComponent],
})
export class AdCheckBoxModule {}
export { AdCheckBoxComponent };
